import { useRouter } from 'next/router'
import { MapBreadcrumbs as View } from 'ui-components'
import { useMap } from '~map-preview/states/map'

export const MapBreadcrumbs = () => {
  const router = useRouter()
  const map = useMap()

  const handleClick = () => {
    router.push('/tags')
  }

  return (
    <View
      map={map}
      onCommunityClick={handleClick}
    />
  )
}
